import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useMembershipSalesV2 } from "./hooks/useMembershipSalesV2";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "membershipSalesReport.info.title",
  rows: [
    "membershipSalesReport.info.clinicMembershipSales",
    "membershipSalesReport.info.employeeMembershipSales",
  ],
};

const MembershipSalesV2 = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useMembershipSalesV2(requestParams);

  const isClinicDataEmpty = !isLoading && !data?.clinicMembershipSales?.length;
  const isProviderDataEmpty =
    !isLoading && !data?.providerMembershipSales?.length;

  const providerData = useMemo(
    () =>
      data?.providerMembershipSales?.map((provider) => ({
        providerName: provider.provider_name,
        membershipSales: provider.total_membership_sales,
      })) || [],
    [data],
  );

  const clinicData = useMemo(
    () =>
      data?.clinicMembershipSales?.map((clinic) => ({
        clinicName: clinic.clinic_name,
        membershipSales: clinic.total_membership_sales,
      })) || [],
    [data],
  );

  const _clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Membership Sales V2"
        selectedClinic={selectedClinic}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getBiMembershipSalesV2()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex flex-col gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Membership Sales", accessor: "membershipSales" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "Membership Sales", accessor: "membershipSales" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default MembershipSalesV2;
